import { Controller } from '@hotwired/stimulus';

export default class StickyTickerController extends Controller {
  connect() {
    this.header = document.querySelector('cmpr-site-header');
    this.container = document.querySelector('.container');
    this.update = this.update.bind(this);

    requestAnimationFrame(() => this.update());
    window.addEventListener('scroll', this.update, { passive: true });
    window.addEventListener('resize', this.update, { passive: true });
  }

  disconnect() {
    window.removeEventListener('scroll', this.update);
    window.removeEventListener('resize', this.update);
  }

  update() {
    const headerBottom = this.header ? this.header.getBoundingClientRect().bottom : 0;
    this.element.style.top = `${Math.max(0, Math.round(headerBottom) - 1)}px`;
    this.container.style.paddingTop = `${this.element.offsetHeight}px`;
  }
}
